import { Routes } from '@angular/router';
import { loginGuard } from './shared/guards/login-guard';
import { authGuard } from './shared/guards/auth-guard';
import { roleGuard } from './shared/guards/role-guard';

export const routes: Routes = [

  {
    path: 'login',
    canMatch: [loginGuard],
    loadComponent: () => import('./auth/login/login.component').then(component => component.LoginComponent
    )
  },
  {
    path: 'forgot-password',
    canMatch: [loginGuard],
    loadComponent: () => import('./auth/forget-password/forget-password.component').then(component => component.ForgetPasswordComponent
    )
  },
  {
    path: 'back-to-login',
    canMatch: [loginGuard],
    loadComponent: () => import('./auth/back-to-login/back-to-login.component').then(component => component.BackToLoginComponent
    )
  },
  {
    path: 'reset-password',
    canMatch: [loginGuard],
    loadComponent: () => import('./auth/reset-password/reset-password.component').then(component => component.ResetPasswordComponent
    )
  },
  {
    path: 'signup',
    canMatch: [loginGuard],
    loadComponent: () => import('./auth/sign-up/sign-up.component').then(component => component.SignUpComponent
    )
  },
  {
    path: '404',
    loadComponent: () => import('./pages/not-found/not-found.component').then(c => c.NotFoundComponent)
  },
  {
    path: 'error',
    loadComponent: () => import('./pages/error/error.component').then(c => c.ErrorComponent)
  },
  {
    path: 'admin',
    canActivate: [authGuard],
    canActivateChild: [authGuard, roleGuard],
    data: {
      roles: ['superadmin']
    },
    loadChildren: () =>
      import('./admin/admin.routes').then(r => r.adminRoutes),
  },
  {
    path: '',
    loadChildren: () =>
      import('./layout/layout-module').then(m => m.LayoutModule),
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

